import { render, staticRenderFns } from "./ProjectMenu.vue?vue&type=template&id=31b70453&scoped=true&"
import script from "./ProjectMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMenu.vue?vue&type=style&index=0&id=31b70453&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b70453",
  null
  
)

export default component.exports